export function bin2string(array) {
	var result = "";
	for (var i = 0; i < array.length; ++i) {
		result += String.fromCharCode(array[i]);
	}
	return result;
}

// 16 bit numbers, flip inputs for little/big endian
export function combineBytes(byte1, byte2) {
	// Combine the two bytes into a 16-bit unsigned integer
	const combined = (byte1 << 8) | byte2;

	// Convert the unsigned integer to a signed 16-bit integer
	return new Int16Array([combined])[0];
}

export function encodeCANPacket(canId, ...payloadBytes) {
	// Allocate a new Uint8Array of the appropriate length
	// 2 bytes for the CAN ID + the number of payload bytes
	let data = new Uint8Array(2 + payloadBytes.length);

	// Encode the CAN ID
	// The ID is shifted right by 3 and then & with 0xFF to fit into the first byte
	data[0] = (canId >> 3) & 0xff;
	// The ID is shifted left by 5 to align the least significant bits of the ID with the second byte
	data[1] = (canId & 0x07) << 5;

	// Add the payload bytes
	payloadBytes.forEach((byte, index) => {
		data[2 + index] = byte;
	});

	return data;
}
